import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
import currentUserState from './current-user-state.js';
const currentUserOrganizationUnitDetailsState = buildServiceState({
    allowEmptyRequest: true,
    key: 'currentOrganizationUnitDetails',
    requireLoggedIn: true,
    service: Core.GetOrganizationUnitDetailed,
    beforeRequest: ({ req, get }) => {
        // The requireEmployee check above will ensure the user is available
        //
        const currentUser = get(currentUserState.response);
        if (!currentUser.User.CurrentOrganizationID) {
            throw new Error('Current user has no current organization');
        }
        const newRequest = {
            ...req,
            ID: currentUser.User.CurrentOrganizationID,
        };
        return newRequest;
    },
});
export default currentUserOrganizationUnitDetailsState;
//# sourceMappingURL=current-user-organization-unit-details-state.js.map